import { render, staticRenderFns } from "./CalibrationFour.vue?vue&type=template&id=939895fe&scoped=true"
import script from "./CalibrationFour.vue?vue&type=script&lang=js"
export * from "./CalibrationFour.vue?vue&type=script&lang=js"
import style0 from "./CalibrationFour.vue?vue&type=style&index=0&id=939895fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939895fe",
  null
  
)

export default component.exports